import URLConfig from '@Config/urls/url.config';
import { LinkItemProps } from '@Layouts/sidebar/AppSidebar';

const URL = URLConfig.CARD_MANAGEMENT_SYSTEM.CARDHOLDER.CARD_DATA_MENU;

const CardDataMenuLink: Array<LinkItemProps> = [
  {
    name: 'Produit Carte',
    link: URL.CARD_PRODUCT,
    level: 3,
  },
  {
    name: 'Client',
    link: URL.CUSTOMER,
    level: 3,
  },
  {
    name: 'Compte',
    link: URL.ACCOUNT,
    level: 3,
  },
  {
    name: 'Carte',
    link: URL.CARD,
    level: 3,
    subMenu: [
      {
        name: "Données Carte",
        link: URL.CARD_DATA,
        level: 4,
      },
      {
        name: "Consultation Des Cartes",
        link: URL.CARD_CONSULTATION,
        level: 4,
      },
    ]
  },
  {
    name: 'Consultation des Statuts Carte',
    link: URL.CARD_STATUS_CONSULTATION,
    level: 3,
  },
  {
    name: 'Historique Statut Carte',
    link: URL.CARD_STATUS_HISTORY,
    level: 3,
  },
  {
    name: 'Historique Remise à Zéro du Compteur Pin',
    link: URL.HISTORY_RESET_PIN_COUNTER,
    level: 3,
  },
  {
    name: 'Historique 3D Secure',
    link: URL['3D_SECURE_HISTORY'],
    level: 3,
  },

];

export default CardDataMenuLink;
